/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AttachmentResponseDTO,
  BodyAddTestCaseAttachmentApiTestCasesIdAttachmentsPost,
  BodyCreateTestcasesApiTestCasesPost,
  BodyUpdateTestcasesApiTestCasesIdPut,
  HTTPValidationError,
  TestCaseGroupCreateDTO,
  TestCaseGroupRefUpdateDTO,
  TestCaseGroupResponseDTO,
  TestCaseGroupUpdateDTO,
  TestCaseListResponseDTO,
  TestCaseResponseDTO,
  TestCaseStatusUpdateDTO,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class TestCases<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags TestCase
   * @name GetTestCaseGroupsApiTestCasesGroupsGet
   * @summary Get Test Case Groups
   * @request GET:/api/test_cases/groups
   * @response `200` `(TestCaseGroupResponseDTO)[]` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  getTestCaseGroupsApiTestCasesGroupsGet = (
    query: {
      /** Project Ref */
      project_ref: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<TestCaseGroupResponseDTO[], HTTPValidationError>({
      path: `/api/test_cases/groups`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TestCase
   * @name CreateTestCaseGroupApiTestCasesGroupsPost
   * @summary Create Test Case Group
   * @request POST:/api/test_cases/groups
   * @response `201` `TestCaseGroupResponseDTO` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  createTestCaseGroupApiTestCasesGroupsPost = (data: TestCaseGroupCreateDTO, params: RequestParams = {}) =>
    this.request<TestCaseGroupResponseDTO, HTTPValidationError>({
      path: `/api/test_cases/groups`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TestCase
   * @name GetTestCaseGroupApiTestCasesGroupsIdGet
   * @summary Get Test Case Group
   * @request GET:/api/test_cases/groups/{_id}
   * @response `200` `TestCaseGroupResponseDTO` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  getTestCaseGroupApiTestCasesGroupsIdGet = (id: number, params: RequestParams = {}) =>
    this.request<TestCaseGroupResponseDTO, HTTPValidationError>({
      path: `/api/test_cases/groups/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TestCase
   * @name UpdateTestCaseGroupApiTestCasesGroupsIdPut
   * @summary Update Test Case Group
   * @request PUT:/api/test_cases/groups/{_id}
   * @response `204` `void` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  updateTestCaseGroupApiTestCasesGroupsIdPut = (id: number, data: TestCaseGroupUpdateDTO, params: RequestParams = {}) =>
    this.request<void, HTTPValidationError>({
      path: `/api/test_cases/groups/${id}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags TestCase
   * @name DeleteTestCaseGroupApiTestCasesGroupsIdDelete
   * @summary Delete Test Case Group
   * @request DELETE:/api/test_cases/groups/{_id}
   * @response `204` `void` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  deleteTestCaseGroupApiTestCasesGroupsIdDelete = (id: number, params: RequestParams = {}) =>
    this.request<void, HTTPValidationError>({
      path: `/api/test_cases/groups/${id}`,
      method: "DELETE",
      ...params,
    });
  /**
   * No description
   *
   * @tags TestCase
   * @name GetTestcasesApiTestCasesGet
   * @summary Get Testcases
   * @request GET:/api/test_cases
   * @response `200` `(TestCaseListResponseDTO)[]` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  getTestcasesApiTestCasesGet = (
    query: {
      /** Project Ref */
      project_ref: number;
      /** Search */
      search?: string | null;
      /** Id */
      id?: number | null;
      /** Priority */
      priority?: number | null;
      /** Group Ref */
      group_ref?: number | null;
      /** Order By */
      order_by?: "priority_asc" | "priority_desc" | "id_asc" | "id_desc" | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<TestCaseListResponseDTO[], HTTPValidationError>({
      path: `/api/test_cases`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TestCase
   * @name CreateTestcasesApiTestCasesPost
   * @summary Create Testcases
   * @request POST:/api/test_cases
   * @response `200` `TestCaseResponseDTO` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  createTestcasesApiTestCasesPost = (data: BodyCreateTestcasesApiTestCasesPost, params: RequestParams = {}) =>
    this.request<TestCaseResponseDTO, HTTPValidationError>({
      path: `/api/test_cases`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TestCase
   * @name GetTestcasesDetailApiTestCasesIdGet
   * @summary Get Testcases Detail
   * @request GET:/api/test_cases/{_id}
   * @response `200` `TestCaseResponseDTO` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  getTestcasesDetailApiTestCasesIdGet = (id: number, params: RequestParams = {}) =>
    this.request<TestCaseResponseDTO, HTTPValidationError>({
      path: `/api/test_cases/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TestCase
   * @name UpdateTestcasesApiTestCasesIdPut
   * @summary Update Testcases
   * @request PUT:/api/test_cases/{_id}
   * @response `204` `void` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  updateTestcasesApiTestCasesIdPut = (
    id: number,
    data: BodyUpdateTestcasesApiTestCasesIdPut,
    params: RequestParams = {},
  ) =>
    this.request<void, HTTPValidationError>({
      path: `/api/test_cases/${id}`,
      method: "PUT",
      body: data,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags TestCase
   * @name DeleteTestcasesApiTestCasesIdDelete
   * @summary Delete Testcases
   * @request DELETE:/api/test_cases/{_id}
   * @response `204` `void` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  deleteTestcasesApiTestCasesIdDelete = (id: number, params: RequestParams = {}) =>
    this.request<void, HTTPValidationError>({
      path: `/api/test_cases/${id}`,
      method: "DELETE",
      ...params,
    });
  /**
   * No description
   *
   * @tags TestCase
   * @name UpdateTestcaseStatusApiTestCasesIdStatusPatch
   * @summary Update Testcase Status
   * @request PATCH:/api/test_cases/{_id}/status
   * @response `204` `void` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  updateTestcaseStatusApiTestCasesIdStatusPatch = (
    id: number,
    data: TestCaseStatusUpdateDTO,
    params: RequestParams = {},
  ) =>
    this.request<void, HTTPValidationError>({
      path: `/api/test_cases/${id}/status`,
      method: "PATCH",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags TestCase
   * @name UpdateTestcaseGroupApiTestCasesIdGroupPatch
   * @summary Update Testcase Group
   * @request PATCH:/api/test_cases/{_id}/group
   * @response `204` `void` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  updateTestcaseGroupApiTestCasesIdGroupPatch = (
    id: number,
    data: TestCaseGroupRefUpdateDTO,
    params: RequestParams = {},
  ) =>
    this.request<void, HTTPValidationError>({
      path: `/api/test_cases/${id}/group`,
      method: "PATCH",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags TestCase
   * @name AddTestCaseAttachmentApiTestCasesIdAttachmentsPost
   * @summary Add Test Case Attachment
   * @request POST:/api/test_cases/{_id}/attachments
   * @response `201` `AttachmentResponseDTO` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  addTestCaseAttachmentApiTestCasesIdAttachmentsPost = (
    id: number,
    data: BodyAddTestCaseAttachmentApiTestCasesIdAttachmentsPost,
    params: RequestParams = {},
  ) =>
    this.request<AttachmentResponseDTO, HTTPValidationError>({
      path: `/api/test_cases/${id}/attachments`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TestCase
   * @name DeleteTestCaseAttachmentApiTestCasesIdAttachmentsAttachmentIdDelete
   * @summary Delete Test Case Attachment
   * @request DELETE:/api/test_cases/{_id}/attachments/{attachment_id}
   * @response `204` `void` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  deleteTestCaseAttachmentApiTestCasesIdAttachmentsAttachmentIdDelete = (
    id: number,
    attachmentId: number,
    params: RequestParams = {},
  ) =>
    this.request<void, HTTPValidationError>({
      path: `/api/test_cases/${id}/attachments/${attachmentId}`,
      method: "DELETE",
      ...params,
    });
}
